import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { message } from 'antd';
import styles from './Dashboard.module.scss';
import TotalView from './TotalView';
import PieView from './PieView';
import AssetsView from './AssetsView';
import ScoreView from './ScoreView';
import { WalletAssetItem } from '../../types/api';
import { getPlus } from '../../utils/count';
import Urls from '../../enum/urls';
import { Codes } from '../../enum';
import { useGlobalState } from '../../store';

const Dashboard: React.FC = () => {
  const { t } = useTranslation();
  const [addressList] = useGlobalState('addressList');
  const [walletAssetList, setWalletAssetList] = useState<WalletAssetItem[]>([]);
  const [listLoading, setListLoading] = useState<boolean>(false);
  const [total, setTotal] = useState<number>(0);

  const initTotalData = () => {
    const result = walletAssetList.reduce((prev, curr) => getPlus(prev, Number(curr.usd)), 0);
    setTotal(result);
  };

  useEffect(() => {
    const source = axios.CancelToken.source();

    if (addressList.length) {
      setListLoading(true);
      axios({
        method: 'post',
        baseURL: process.env.REACT_APP_ONTO_URL,
        url: Urls.GetWalletAsset,
        headers: {
          CHANNEL: 'oscore',
        },
        data: {
          address_list: addressList,
          oep4: [],
          erc20: [],
          nep5: [],
          klay: [],
          trc10: [],
          trc20: [],
        },
        cancelToken: source.token,
      }).then(({ data }) => {
        if (data.Error === Codes.Success) {
          const result: WalletAssetItem[] = data.Result.token_list;
          setWalletAssetList(result.filter((item => Number(item.usd) > 0)));
          // setWalletAssetList(result.filter((item: any) => Number(item.exact_amount) > 0));
        } else {
          message.error(data.Desc);
        }
        setListLoading(false);
      }).catch((e) => {
        if (!axios.isCancel(e)) { // no setListLoading when unmount
          message.error(e.message);
          setListLoading(false);
        }
      });
    } else {
      source.cancel();
      setListLoading(false);
      setWalletAssetList([]);
    }

    return () => {
      source.cancel();
    };
  }, [addressList]);

  useEffect(() => {
    initTotalData();
    // eslint-disable-next-line
  }, [walletAssetList]);

  return (
    <div className="g-container">
      <h2 className="g-sub-title first">{t('total_balance')}</h2>
      <div className={styles.split}>
        <div className="g-card">
          <TotalView walletAssetList={walletAssetList} />
        </div>
        <div className="g-card">
          <ScoreView />
        </div>
      </div>
      <h2 className="g-sub-title">{t('balance_statistics')}</h2>
      <div className="g-card">
        <PieView addressList={walletAssetList} total={total} />
      </div>
      <h2 className="g-sub-title">{t('tokens_list')}</h2>
      <AssetsView list={walletAssetList} loading={listLoading} />
    </div>
  );
};

export default Dashboard;
